<template>
  <div class="text-xs-center">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" class="notiContent">
      <template slot='activator'>
        <v-btn flat icon>
          <v-badge overlap class="badge-xs" :value="isNewNotification" color="red">
            <template slot="badge">
              <span>!</span>
            </template>
            <v-icon class="noti-icon">
              notifications
            </v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card class="notification-color">
        <v-list class="pa-0 notification-color">
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title class="text--primary">{{ $t('Notification') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>
        <v-list v-if="showNotification" two-line class="notification-content notification-color">
          <template v-for="(notification, index) in notifications">
            <v-list-tile :key="notification._id" avatar ripple @click="goto(notification)">
              <v-list-tile-content>
                <v-list-tile-title class="text--primary">{{ notification.title }}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{ notification.message }}</v-list-tile-sub-title>
                <v-list-tile-sub-title class="text--primary">{{ notification.added_on | formatFullDate }}</v-list-tile-sub-title>
              </v-list-tile-content>

            </v-list-tile>
            <v-divider v-if="index + 1 < notifications.length" :key="index"></v-divider>
          </template>
        </v-list>
        <v-card-actions class="text-md-center pa-0" @click="menu = false">
          <router-link to="/notification" @click="menu = false" class="full-width pa-2 primaryText--text">{{ $t('View more') }}</router-link>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { NotificationMixin } from '@/util/mixin/NotificationMixin'
import moment from 'moment'

export default {
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  mixins: [NotificationMixin],
  data: () => ({
    menu: false,
    isNewNotification: false
  }),
  mounted() {
    this.isNewNotification = this.lastNotificationViewed < this.latestNotificationTime
  },
  computed: {
    ...mapGetters(['getUserInfo', 'getGeneralState']),
    showNotification() {
      return !!this.notifications.length
    },
    lastNotificationViewed() {
      return this.getGeneralState('userData').lastNotificationViewed;
    },
    latestNotificationTime() {
      return this.notifications.length > 0 ? this.notifications[0].added_on : 0
    }
  },
  methods: {
    ...mapActions(['setLatestNotificationViewTimestamp'])
  },
  watch: {
    menu(value) {
      if (!value) {
        this.setLatestNotificationViewTimestamp(
          {
            userId: this.getUserInfo('userId'),
            details: {
              last_viewed_notification_time: moment().format('X')
            }
          }
        )
      }
    },
    notifications() {
      this.isNewNotification = this.lastNotificationViewed < this.latestNotificationTime
    },
    lastNotificationViewed() {
      this.isNewNotification = this.lastNotificationViewed < this.latestNotificationTime
    }
  },
  filters: {
    formatFullDate(time) {
      return moment(time, 'X').format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style scoped>

  .noti-icon {
    color: #BABABA !important;
  }
  .notiContent {
    z-index: 3;
  }
  .theme--light .noti-icon {
    color: #333333 !important;
  }
  
  .full-width {
    width: 100%;
  }

  .badge-xs .v-badge__badge {
    height: 16px;
    width: 16px;
    font-size: 11px;
  }

  .notification-content {
    height: 300px;
    max-height: 300px;
    overflow-y: auto;
  }

  .notification-color {
    background: var(--v-bg-base);
  }

  @media (max-width:510px) {
    .notification-content {
      height: 200px;
      max-height: 200px;
    }
  }
</style>
